import { ShieldCheck } from "lucide-react";

export const PolicyNote = ({ compact }) => (
  <div data-testid="refund-policy-note" className="rounded-2xl border border-accent/30 bg-accent/5 p-4 flex gap-3">
    <ShieldCheck className="w-5 h-5 text-accent shrink-0 mt-0.5" strokeWidth={1.5} />
    <div className="text-sm leading-relaxed">
      <p className="font-bold text-[#1A2E1C]">No substitutions. Fair, same-day refunds.</p>
      {!compact && (
        <p className="text-stone-600 mt-1">
          We pack from our own stock. If any item is unavailable at packing, we remove only that item — never swap it.
          For cash/UPI-at-delivery orders the amount is deducted from your bill; for bank transfers, the line amount is refunded the same day.
          Prices are fixed at the moment you place your order.
        </p>
      )}
    </div>
  </div>
);
